import SelectAutocompleteWithBash from '../Common/SelectAutocompleteWithBash';

const SelectAutocompleteWithBashWrapper = objProps => {
  return <SelectAutocompleteWithBash {...objProps.field} {...objProps} />;
};

export default SelectAutocompleteWithBashWrapper;
